import { getAvailabilityErrorById } from 'apps/cart/api/utilities';

import { AvailabilityCheck } from './api';

const availabilityCheckInterval = 60000;
let availabilityCheckIntervalID = -1;

function availabilityCheck (cartModel) {

	// Availability API will never return CartStatus of 1, only 34 or 35, so we catch that in the error callback
	AvailabilityCheck().then((response) => {

		// Error code 34 means product is no longer available
		if (getAvailabilityErrorById(response, 34)) {

			cartModel.update(response);

		}

	});

}

function stopAvailabilityCheck () {

	clearInterval(availabilityCheckIntervalID);

}

function startAvailabilityCheck (cartModel) {

	stopAvailabilityCheck();

	availabilityCheckIntervalID = setInterval(availabilityCheck, availabilityCheckInterval, cartModel);

}

export { startAvailabilityCheck, stopAvailabilityCheck };
